'use client';
import './style.sass';

import React from 'react';

import { listPath, listTitle } from './constants';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from 'shared/utilities/GetAdjacentCase/getAdjacentCase';
import About from '../reusable-components/layouts-components__fondrt/about';
import AboutUs from '../reusable-components/layouts-components__fondrt/about-us';
import Description from '../reusable-components/layouts-components__fondrt/description';
import Plan from '../reusable-components/layouts-components__fondrt/plan';
import Problem from '../reusable-components/layouts-components__fondrt/problem';
import Process from '../reusable-components/layouts-components__fondrt/process';
import Task from '../reusable-components/layouts-components__fondrt/task';
import Team from '../reusable-components/layouts-components__fondrt/team';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';

const FondRT = () => {
    const casePathname = '/cases/development/fondrt';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section>
            <TitleCase
                img="/images/pic/new-fondrt/banner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="frt"
            />
            <Description />
            <Task />
            <Problem />
            <About />
            <Process />
            <Plan />

            <ScrollAnimation className="fontrt-about__us">
                <AboutUs />
            </ScrollAnimation>

            <Team />

            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>

            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default FondRT;
